import { createActions } from "redux-actions";

export const {
  getPersonList,
  setPersonList,
  addPersonToList,
  addPersonToListSuccess,
  addPersonToListFailure,
  deletePerson,
  deletePersonSuccess,
  deletePersonFailure,
  editPerson,
  editPersonSuccess,
  editPersonFailure
} = createActions(
  {
    GET_PERSON_LIST: (orderId, pagination, sort, personTypeKey = {}) => ({
      orderId,
      pagination,
      sort,
      personTypeKey
    }),
    SET_PERSON_LIST: persons => ({ persons })
  },
  "ADD_PERSON_TO_LIST",
  "ADD_PERSON_TO_LIST_SUCCESS",
  "ADD_PERSON_TO_LIST_FAILURE",
  "DELETE_PERSON",
  "DELETE_PERSON_SUCCESS",
  "DELETE_PERSON_FAILURE",
  "EDIT_PERSON",
  "EDIT_PERSON_SUCCESS",
  "EDIT_PERSON_FAILURE"
);
